import { render } from "./Form.vue?vue&type=template&id=6d61928b&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=6d61928b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6d61928b"

export default script